import { render, staticRenderFns } from "./BaseLink.vue?vue&type=template&id=18b5fe8e&scoped=true&"
import script from "./BaseLink.vue?vue&type=script&lang=ts&"
export * from "./BaseLink.vue?vue&type=script&lang=ts&"
import style0 from "./BaseLink.vue?vue&type=style&index=0&id=18b5fe8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b5fe8e",
  null
  
)

export default component.exports